'use strict';

const { getDependencyClass } = require('../../lib/dependencies.js');
const performanceMeasure = require('../../lib/performanceMeasure.js');
let measure = performanceMeasure('webcomponents:nonPersonalizedRecommendationsTracking');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * NonPersonalizedRecommendationsTracking is a Web Component responsible for tracking non-A/B tested
     * content by LiftIgniter's API.
     * NonPersonalizedRecommendationsTracking relies on the server-side LiftIgniter module, which defines and
     * uses $p to send beacons per pageview.
     *
     * Documentation: https://liftigniter.readme.io/docs/introduction
     *
     * @example
     *
     *     <phoenix-non-personalized-recommendations-tracking
     *          ...
     *         config={"siteDomain": "fashionista.com",
     *                 "size":9,
     *                 "widgetName":"This-is-widget-name",}
     *     </phoenix-non-personalized-recommendations-tracking>
     */
    class NonPersonalizedRecommendationsTracking extends pageClass.PhoenixElement {
        set loaded(val) {
            if (val) {
                this._isLoaded = val;
            }
        }

        get loaded() {
            return this._isLoaded;
        }

        get widgetName() {
            return this.config.widgetName;
        }

        connectedCallback() {
            super.connectedCallback();
            window.liftIgniterPromise
                .then(() => {
                    const timeoutPromise = new Promise((resolve, reject) => {
                        setTimeout(() => {
                            reject('li beacon failed to load in 5 seconds.');
                        }, 5000);
                    });
                    Promise.race([window.liftIgniterLoadPromise, timeoutPromise])
                        .then(() => {
                            if (!this.loaded) {
                                this.loaded = true;
                                this.trackRecommendations('base');
                            }
                        })
                        .catch((err) => {
                            if (!this.loaded) {
                                // eslint-disable-next-line no-console
                                console.error(err);
                                this.loaded = true;
                                this.trackRecommendations('base');
                            }
                        });
                })
                .catch((err) => {
                    // eslint-disable-next-line no-console
                    console.error(err && err.message ? err.message : err);
                });
        }

        trackRecommendations(slice) {
            const recommendedUnitSelector = 'phoenix-super-link';
            window.liftIgniterPromise.then(() => {
                if (!this.querySelector('phoenix-non-personalized-recommendations-tracking')) {
                    const elements = this.querySelectorAll(recommendedUnitSelector);
                    window.$p('track', {
                        elements,
                        name: this.widgetName,
                        source: slice,
                        noTag: true,
                    });
                }
            });
        }
    }

    window.customElements.define(
        'phoenix-non-personalized-recommendations-tracking',
        NonPersonalizedRecommendationsTracking
    );
    measure.end();
});
